// data editor change type constants
export const DATA_EDITOR_SET = 'set';
export const DATA_EDITOR_UNSET = 'unset';
export const DATA_EDITOR_UPDATE = 'update';
export const DATA_EDITOR_BATCH_UPDATE = 'batch_update';
